import React from 'react'
import isEqual from 'lodash.isequal'
import { DetailInfo } from '@softwaredev_cegeka/stix-form'
import { Tabs, Skeleton } from '@softwaredev_cegeka/stix-core'
import BaseSearchableList from 'src/components/SearchableList'
import { AuthApi } from 'src/api/authApi'
import { authenticatedUserStore } from 'src/stores'

const SERVICE_ACTIONS_TAB_MAPPINGS = {
    SERVICE_ACTIONS_TAB: {
        entityName: 'actions',
        dataField: 'actions',
        itemId: 'id',
        itemDisplay: item =>
            `${item.service_namespace}:${item.category}:${item.key}`,
        detailItemDisplay: item => item.description,
        selectDisplay: item =>
            `${item.service_namespace}:${item.category}:${item.key}`,
    },
}

/**
 * Service Drawer content
 * @returns {*[]}
 */
export default class ServiceDrawerContent extends React.Component {
    state = {
        loading: false,
        selectedServiceActions: {
            actions: [],
        },
    }

    authClient = new AuthApi(authenticatedUserStore.authToken)

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(prevProps.selectedService, this.props.selectedService)) {
            this.getServiceActions()
        }
    }

    componentWillUnmount() {
        this.authClient.cancelRequest()
    }

    getServiceActions = () => {
        const { selectedService } = this.props
        this.setState(
            {
                loading: true,
            },
            () => {
                this.authClient
                    .fetchServiceActions(selectedService.id)
                    .then(response => {
                        this.setState({
                            selectedServiceActions: {
                                actions: response?.data?.results,
                            },
                            loading: false,
                        })
                    })
                    .catch(err => {
                        this.setState({
                            loading: false,
                        })
                    })
            }
        )
    }

    render() {
        const { selectedService, removeServiceAction } = this.props
        const content = [
            {
                label: 'Namespace',
                value: selectedService.namespace,
            },
        ]

        const descriptionContent = [
            {
                label: 'Short description',
                value: (
                    <span className="short-description-info">
                        {selectedService.short_description}
                    </span>
                    // TODO: update detailInfo in stixx so component can be customized more easily
                ),
            },
        ]
        return (
            <>
                <DetailInfo data={content} />
                <DetailInfo singleColumn data={descriptionContent} />
                <Tabs
                    variant="material"
                    defaultActiveKey="serviceActions"
                    id="service-drawer-content-tabs"
                >
                    <Tabs.Pane
                        eventKey="serviceActions"
                        title="Service Actions"
                    >
                        {this.state.selectedServiceActions.actions &&
                        !this.state.loading ? (
                            <BaseSearchableList
                                data={this.state.selectedServiceActions}
                                type={
                                    SERVICE_ACTIONS_TAB_MAPPINGS.SERVICE_ACTIONS_TAB
                                }
                                removeEntityMethod={removeServiceAction}
                                emptyListMessage={`No ${SERVICE_ACTIONS_TAB_MAPPINGS.SERVICE_ACTIONS_TAB.entityName} linked to this group.`}
                                addEntityUrl={`/service-form/${selectedService.id}/service-action`}
                            />
                        ) : (
                            <Skeleton />
                        )}
                    </Tabs.Pane>
                </Tabs>
            </>
        )
    }
}
